<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Cor Veículo'"
      :titulo="'cor'"
    />

    <!--Formulário de Cadastro -->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Cadastrar Cor</span>
          </div>
        </div>
        <form @submit.prevent="onSubmit">
          <div class="row g-2 p-2">
            <!--Descrição-->
            <div class="col-12 col-sm-9 col-md-9 col-lg-10 col-xl-10">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="descricao"
                  required
                  autocomplete="off"
                />
                <label>Descrição</label>
              </div>
            </div>
            <!--Status-->
            <div class="col-12 col-sm-3 col-md-3 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="status"
                  required
                >
                  <option value="0">Desabilitado</option>
                  <option value="1">Habilitado</option>
                </select>
                <label>Status</label>
              </div>
            </div>
            <!-- Seção: Ações -->
            <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
              <!-- Botões de Ação - Mobile (apenas ícones) -->
              <div class="d-flex d-md-none gap-2">
                <button
                  type="submit"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                >
                  <i class="bi bi-plus-circle" title="Inserir"></i>
                </button>
              </div>
              <!-- Botões de Ação - Tablet (768px - 991px) -->
              <div class="d-none d-md-flex d-lg-none gap-2">
                <button
                  type="submit"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
              <!-- Botões de Ação - Desktop (≥ 992px) -->
              <div class="d-none d-lg-flex gap-2">
                <button
                  type="submit"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div v-if="abrir_modal">
          <Message :msg="msg" v-show="msg" />
        </div>
      </div>
    </div>

    <!--Bloco do Filtro-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-funnel fs-5 icon-text-form"></i>
            <span class="txt-title-form">Filtro</span>
          </div>
        </div>
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-7 col-md-7 col-lg-8 col-xl-8">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="searchTitle"
              />
              <label>Descrição</label>
            </div>
          </div>

          <div class="col-12 col-sm-3 col-md-3 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <select class="form-select txt-form-input" v-model="searchStatus">
                <option value="">------</option>
                <option value="0">Desabilitado</option>
                <option value="1">Habilitado</option>
              </select>
              <label>Status</label>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="pageSize"
                @change="handlePageSizeChange(pageSize)"
              >
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
              <label>Itens Pág.</label>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  retrieveCores();
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveCores();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveCores();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tabelas-->
    <div class="card-container">
      <div class="card">
        <div class="d-md-none">
          <!-- Indicador de Carregamento -->
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in cores"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Status:</strong>
                      {{ item.status }}
                    </p>

                    <button
                      type="button"
                      class="btn round-btn align-self-end"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_cor(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <!-- Indicador de Carregamento -->
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in cores"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Status:</strong>
                      {{ item.status }}
                    </p>

                    <button
                      type="button"
                      class="btn btn-modal"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_cor(item)"
                    >
                      <span>Editar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-lg-block">
          <table class="table rf_texto" v-if="!isLoading">
            <thead>
              <tr>
                <th scope="col">Descrição</th>
                <th scope="col">Status</th>
                <th scope="col">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in cores"
                :key="item.descricao"
                class="table-linha"
              >
                <td>{{ item.descricao }}</td>
                <td>{{ getStatus(item.status) }}</td>
                <td>
                  <button
                    type="button"
                    class="dropdown-toggle-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_cor(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="loading-indicator">Carregando...</div>
        </div>
        <pagination
          v-if="cores.length"
          :total="totalItems"
          :limit="pageSize"
          :offset="currentPage"
          :totalPages="Math.ceil(totalItems / pageSize)"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <!-- Modal para edição -->
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal"> Editar Cor</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_descricao"
                    required
                  />
                  <label>Descrição</label>
                </div>
              </div>
              <!--Status-->
              <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_status"
                    required
                  >
                    <option value="0">Desabilitado</option>
                    <option value="1">Habilitado</option>
                  </select>
                  <label>Status</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="update()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->

    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
//import DataService from "../../services/DataService";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";
export default {
  name: "Usuários",
  components: {
    SidebarVue,
    Navgator,
    Pagination,
    Message,
    RodapeVue
  },
  data() {
    return {
      cores: [],
      isLoading: false,

      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,
      //Campos Cadastro
      user_id: "",
      descricao: "",
      status: "",
      btn_cadastrar: false,

      /// Campos Modal Editar
      edit_id: "",
      edit_descricao: "",
      edit_status: "",

      //Params
      searchTitle: "",
      searchStatus: "",
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [5, 10, 15, 35, 50, 10],
      pageSize: 10
    };
  },
  mounted() {
    this.retrieveCores();
  },
  methods: {
    resetForm() {
      (this.descricao = ""), (this.status = "");
    },
    getStatus(status) {
      return status === 0 ? "Desabilitado" : "Habilitado";
    },
    async onSubmit() {
      try {
        console.log("Aqui");
        const resp = await fetch(`${process.env.VUE_APP_API_URL}cor`, {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            descricao: this.descricao,
            status: this.status
          })
        })
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            if (resposta.StatusOk == 200) {
              this.abrir_modal = true;
              this.msg = resposta.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
              this.resetForm();
              this.retrieveCores();
            }
            if (resposta.StatusOk == 204) {
              this.abrir_modal = true;
              this.msg = resposta.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
            }
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
        console.log(resp);
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    //Buscar dados no banco de dados
    getRequestParams(searchTitle, page, pageSize, searchStatus) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (searchStatus) {
        params["status"] = searchStatus;
      }
      return params;
    },
    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveCores(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveCores();
    },
    async retrieveCores(page = this.page) {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          page,
          this.pageSize,
          this.searchStatus
        );
        const response = await userService.getCores(params);
        const { cores, totalPages, totalItems } = response.data;
        this.cores = cores;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
        console.log(response.data);
        return true;
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },

    async editar_cor(item) {
      (this.edit_id = item.id),
        (this.edit_descricao = item.descricao),
        (this.edit_status = item.status);
    },
    async update() {
      const token = this.$store.state.auth.user.accessToken;
      //const id_userCad = this.$store.state.auth.user.id;
      const headers = {
        "x-access-token": token
      };
      const dados = {
        id: this.edit_id,
        descricao: this.edit_descricao,
        status: this.edit_status
      };

      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}cor/${this.edit_id}`,
        dados,
        { headers }
      );
      if (response.data.StatusOk == 200) {
        this.abrir_modal = true;
        this.msg = response.data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
        this.resetForm();
        this.retrieveCores();
      }
    }
  }
};
</script>
